// extracted by mini-css-extract-plugin
export default {"container":"Endorsement_2_container__lW+Ww","img":"Endorsement_2_img__U1xIH","h2":"Endorsement_2_h2__k+r81","p":"Endorsement_2_p__1kubV"};